
import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';
import store from '@/store';
import { convertToArabicNumber } from '@/helpers/convertToArabicNumber';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  data(): { arabicAddress: string } {
    return { arabicAddress: '' }
  },
  computed: {
    invoiceDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    customerDetails: function(): any {
      return this.getVariable(this.input.config.customerDetailsVariable);
    },
    loadingManifestId: function(): any {
      return _.get(this.invoiceDetails, 'loadingManifests.0._id',0);
    },
    customerPo: function(): any {
      return _.get(this.invoiceDetails, 'orders[0].id.customerPO', 0)  || _.get(this.invoiceDetails, 'callOffs.0.callOff.customerPO', 0);
    },
    quotationId: function(): number {
      return _.get(this.invoiceDetails, 'callOffs.0.callOff.quotationId', 0);
    },
    companyAddress: function(): any {
      return store.state.staticData['company-detail']
    },
    addressKey: function(): string {
      return this.input.config.billingAddressKey || 'address';
    },
    billingAddress: function(): string {
      if(_.get(this.customerDetails, `${this.addressKey}.alias_en`)) {
        return _.get(this.customerDetails, `${this.addressKey}.alias_en`);
      } else {
        return this.getCityAndCountryFromAddress(this.customerDetails[this.addressKey]);
      }
    },
    nationalAddress: function(): { en: string, ar: string } | null {
      const nationalAddress = _.get(this.customerDetails, 'nationalAddress', '');
      if(!nationalAddress || !nationalAddress.en) return null;
      const engAddress = `${nationalAddress.en.buildNumber}, ${nationalAddress.en.streetName}, ${nationalAddress.en.district}, ${nationalAddress.en.cityName}, ${nationalAddress.en.countryCode} - ${nationalAddress.en.postalCode}`;
      const arabicAddress = `${nationalAddress.ar.buildNumber} ,${nationalAddress.ar.streetName} ,${nationalAddress.ar.district} ,${nationalAddress.ar.cityName} ,${nationalAddress.ar.countryCode} - ${nationalAddress.ar.postalCode}`;
      return { en: engAddress, ar: arabicAddress };
    }
  },
  watch: {
    async customerDetails() {
      if(!this.arabicAddress) {
        if(_.get(this.customerDetails, `${this.addressKey}.alias_ar`)) {
          this.arabicAddress = _.get(this.customerDetails, `${this.addressKey}.alias_ar`);
        } else {
          const formattedAddress = _.get(this.customerDetails, `${this.addressKey}.formatted_address`);
          if(formattedAddress) {
            this.arabicAddress = await this.getArabicAddress(this.customerDetails[this.addressKey].formatted_address);
          }
        }
      }
    }
  },
  async mounted() {
    if(!this.arabicAddress) {
      if(_.get(this.customerDetails, `${this.addressKey}.alias_ar`)) {
        this.arabicAddress = _.get(this.customerDetails, `${this.addressKey}.alias_ar`);
      } else {
        const formattedAddress = _.get(this.customerDetails, `${this.addressKey}.formatted_address`);
        if(formattedAddress) {
          this.arabicAddress = await this.getArabicAddress(this.customerDetails[this.addressKey].formatted_address);
        }
      }
    }
  },
  methods: {
    async getArabicAddress(searchString: string): Promise<string> {
      const apiResponse: any = await axios
        .get(`https://maps.google.com/maps/api/geocode/json?address=${searchString}&key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&language=ar-SA`);
      return this.getCityAndCountryFromAddress(apiResponse.data.results[0]);
    },
    getCityAndCountryFromAddress(addressObject: any): string {
      const addressComponents: any[] = _.get(addressObject, 'address_components');
      if(!addressComponents) return '';
      const cityComponent = addressComponents.find((addressComponent: any) => addressComponent.types.includes('locality'));
      const countryComponent = addressComponents.find((addressComponent: any) => addressComponent.types.includes('country'));
      return `${cityComponent.long_name}, ${countryComponent.long_name}`;
    },
    convertToArabicNo: function(numValue: number): string {
      return convertToArabicNumber(numValue);
    },
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
